/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment, useEffect, useState } from 'react'
import * as _ from 'lodash'
import { LS_SPORT_ID_ICON_MAP, SPORT_ID_ICON_MAP } from '@shared/SportIdGroup'
import { ArrDayText, HitStateToText } from '@game/util'
import {
  BET_CANCEL_TYPE,
  BET_HIT_STATE,
  BET_TYPE_ON,
  LS_MATCH_STATUS,
  MATCHUP_CATEGORY,
} from 'adv-protocol/src/GameCommon'
import { BettingFoldData, BettingFoldGrouped, BettingRecordTrack } from '@store/bettingHistoryStore'
import dateFormat from 'dateformat'
import { MatchRecordButton } from '@components/Button/MatchRecordButton'
// css
import { BettingHistoryShareBtnStyle, Button } from '@styles/button.style'
import { TimerIco } from '@shared/Icon/EtcIcon'
import { EventStatusType, ProducerType } from '@game-type/betradar-type'
import * as ErrorCodes from 'adv-protocol/src/ErrorCodes'
import { BET_HISTORY_CLUB_ALL, BETTING_HISTORY_TAB_KEY } from '@constants/index'
import { isLsportsEnv } from '@utils/utils'
import { ListItemFoldWrap } from './index.style'
import { Checkbox } from 'antd'
import { observer } from 'mobx-react'
import { PAGE_TYPE } from '@interface/common'
import useRootStore from '@store/useRootStore'
import { TIMELINE_POPUP_ENABLED_SPORT_IDS } from '@game-type/game-market-types'
import { LiveTagIco } from '@shared/Icon/MatchupIcon'
import { FROM_VIEW_TYPE } from '@v2/constants/common'

interface BettingHistoryListItemFoldProps {
  track?: BettingRecordTrack
  fold: BettingFoldGrouped
  foldData: BettingFoldData
  betCanceled: boolean
  betCancelType: BET_CANCEL_TYPE
  bettorBetId: string
  clubId: string
  isShareHistory: boolean
  fetchItems?: (resetForce: boolean, clubId: string) => Promise<void>
  currentTabKey?: BETTING_HISTORY_TAB_KEY
  pageType?: PAGE_TYPE
  fromViewType?: FROM_VIEW_TYPE
}

let timer = null

export const BettingHistoryListItemFold: React.FC<BettingHistoryListItemFoldProps> = observer((
  props: BettingHistoryListItemFoldProps,
) => {
  const { bettingHistoryStore } = useRootStore()
  const {
    track,
    fold,
    foldData,
    betCanceled,
    bettorBetId,
    clubId,
    isShareHistory,
    fetchItems,
    pageType,
    betCancelType,
    currentTabKey,
    fromViewType,
  } = props
  const { homeTeamName, awayTeamName, sportId, matchId, homeScore, awayScore, isOverTimeMatch } = fold
  const {
    marketName, selectionName, hitState, specialBetValue, outcomeRate, marketType,
    selection, specifiers, userPickWritten, typeOn, producerId,
  } = foldData
  const { dateOfMatch } = fold
  const dateInst = new Date(dateOfMatch)
  const dateText = dateFormat(dateOfMatch, 'mm/dd')
  const timeText = dateFormat(dateOfMatch, 'HH:MM')
  const monthText = ArrDayText[new Date(dateInst).getDay()]
  const dateOfMatchText = `${dateText}(${monthText}) ${timeText}`
  const [closeRequest, setCloseRequest] = useState(fold.closeRequest)
  const [requestButtonClassName, setRequestButtonClassName] = useState('')
  const [requestButtonText, setRequestButtonText] = useState('')
  const [requestButtonActive, setRequestButtonActive] = useState(false)

  const isActiveScore = !!(homeScore !== undefined && awayScore !== undefined)
  let homeScoreClassName = ''
  let awayScoreClassName = ''
  if (isActiveScore) {
    homeScoreClassName = homeScore > awayScore ? 'value win' : 'value'
    awayScoreClassName = homeScore < awayScore ? 'value win' : 'value'
  }

  const KeepBtn = () => {
    let keepButton
    // TODO 요청 완료 시 <Button>에 'complete' className을 추가해주시면 됩니다.
    switch (hitState) {
      case BET_HIT_STATE.ONGOING:
        keepButton =
          <Button className={requestButtonClassName} onClick={onClickRequestDeadline}>
            <TimerIco/>
            {requestButtonText}
          </Button>
        break
    }

    if (betCanceled) {
      keepButton = null
    }

    return keepButton
  }

  const ScoreBtnClass = () => {
    let className

    switch (hitState) {
      default:
        if (!_.includes(TIMELINE_POPUP_ENABLED_SPORT_IDS, sportId)) {
          className = 'score-btn underline no-record-btn'
        } else{
          className = 'score-btn underline'
        }
        break
    }

    if (betCanceled) {
      className = 'score-btn underline'
    }

    return className
  }

  const rateTemplate = rate => {
    return _.toNumber(rate).toFixed(2)
  }

  const isMatchClosed = (): boolean => {
    if (isLsportsEnv()) {
      return fold.match_status && fold.match_status === LS_MATCH_STATUS.FINISHED
    }

    return fold.match_status && fold.match_status === EventStatusType.Closed
  }

  let withBrace = false

  const makeCustomSelectionName = (): string[] => {
    let name = selectionName.replace(specialBetValue, '')
    if (name.indexOf('()') > 0) {
      withBrace = true
      name = name.split(' ')[0]
    }

    const names = []
    const slashIndex = name.indexOf('/')
    names.push(name.substr(0, slashIndex))
    names.push(name.substr(slashIndex + 1))
    return names
  }

  const makeSelectionNameElement = () => {
    const viewKey = `BettingHistoryListItemFold:Select:${matchId}`
    const names = makeCustomSelectionName()
    return (
      <span key={viewKey} className="select-wrap">
        {names.map(name => {
          return (<span key={`${viewKey}:${name}`} className="select item">{name}</span>)
        })}
      </span>
    )
  }

  const makeHitStateElement = () => {
    let element

    switch (hitState) {
      case BET_HIT_STATE.SUCCESS:
        element = <span className="success state">{HitStateToText(hitState)}</span>
        break
      case BET_HIT_STATE.FAIL:
        element = <span className="fail state">{HitStateToText(hitState)}</span>
        break
      case BET_HIT_STATE.CANCEL:
        element = <span className="cancel state">{HitStateToText(hitState)}</span>
        break
      case BET_HIT_STATE.ONGOING:
        element = <span className="ongoing state">{HitStateToText(hitState)}</span>
        break
    }

    if (betCanceled) {
      if (currentTabKey === BETTING_HISTORY_TAB_KEY.SHARED || isShareHistory) {
        element = <span className="cancel bettor state">{HitStateToText(BET_HIT_STATE.CANCEL, betCancelType)}</span>
      } else {
        element = <span className="cancel state">{HitStateToText(BET_HIT_STATE.CANCEL)}</span>
      }
    }

    return element
  }

  const makeSelectMatchElement = () => {
    const selectMatch = []
    selectMatch.push(
      makeSelectionNameElement(),
    )
    return selectMatch
  }

  const makeDomScore = () => {
    if (isMatchClosed()) {
      const homeTeamEmblem = fold.homeTeamEmblem
      const awayTeamEmblem = fold.awayTeamEmblem
      const isLiveMatch = track.bet.category === MATCHUP_CATEGORY.LIVE
        || track.bet.category === MATCHUP_CATEGORY.LIVE_DETAIL

      if (isActiveScore) {
        return (
          <Fragment>
            {isOverTimeMatch && <span className="overtime">연장</span>}
            <div className="score">
              {_.includes(TIMELINE_POPUP_ENABLED_SPORT_IDS, sportId) &&
                <MatchRecordButton
                  pageType={PAGE_TYPE.BETTING_HISTORY}
                  matchRecordSimpleMatchInfo={{
                    matchId,
                    sportId,
                    homeScore,
                    awayScore,
                    homeTeamName,
                    awayTeamName,
                    homeTeamEmblem,
                    awayTeamEmblem,
                    isLiveMatch,
                  }}
                />
              }
              <span className={homeScoreClassName}>{homeScore}</span>
              <span className="center">:</span>
              <span className={awayScoreClassName}>{awayScore}</span>
            </div>

          </Fragment>
        )
      }

      return (<span className="center">-</span>)
    }

    return ('')
  }

  const onClickRequestDeadline = async () => {
    if (closeRequest) {
      return
    }

    clearTimeout(timer)
    timer = setTimeout(async () => {
      const result = await bettingHistoryStore.fetchCloseBet(
        matchId, marketType, specifiers,
        bettorBetId, selection, clubId)

      if (result) {
        if (result.result) {
          setCloseRequest(result.result)
        } else if (result.errcode && result.errcode === ErrorCodes.ERR.CLOSED_BET_FOLD) {
          if (fetchItems) {
            await fetchItems(true, BET_HISTORY_CLUB_ALL)
          }
        }
      }
    }, 500)
  }

  const updateRequestButton = () => {
    let isRequestButtonActive = !!(isMatchClosed() && !isShareHistory)
    if (fold.closeCompleted && fold.closeCompleted === true) {
      isRequestButtonActive = false
    }

    setRequestButtonActive(isRequestButtonActive)
    if (isMatchClosed) {
      if (closeRequest === false) {
        setRequestButtonClassName('request-btn')
        setRequestButtonText('마감요청')
      } else if (closeRequest === true) {
        setRequestButtonClassName('request-btn complete')
        setRequestButtonText('요청완료')
      }
    }
  }

  useEffect(() => {
    updateRequestButton()
  }, [closeRequest])

  const onClickBetHistoryItemSelectHandler = () => {
    bettingHistoryStore.setSelectedBettingHistoryByBettingRecordTrack(track, fromViewType)
    bettingHistoryStore.setSelectedBettingHistoryFold(fold, fromViewType)
    bettingHistoryStore.setSelectedBettingHistoryFoldData(foldData, fromViewType)
  }

  const fromUserPick = () => {
    return pageType === PAGE_TYPE.USER_PICK || pageType === PAGE_TYPE.USER_PICK_DETAIL
      || pageType === PAGE_TYPE.MATCHUP_DETAIL_PICK
  }

  let bettingHistoryFoldItem

  if (fromUserPick()) {
    const {
      selectedBettingHistory, selectedBettingHistoryFold, selectedBettingHistoryFoldData,
    } = bettingHistoryStore
    let checkedFold = false
    if (selectedBettingHistoryFold[fromViewType]?.matchId === matchId
      && selectedBettingHistoryFoldData[fromViewType]?.marketType === marketType
      && selectedBettingHistory[fromViewType]?.betId === bettorBetId
    ) {
      checkedFold = true
    }
    if (userPickWritten) {
      bettingHistoryFoldItem = (
        <p className="info-txt">이미 작성한 경기입니다.</p>
      )
    } else if (hitState === BET_HIT_STATE.ONGOING) {
      bettingHistoryFoldItem = (
        <Checkbox
          key={`BettingHistoryListItem:Checkbox:${bettorBetId}:${matchId}:${marketType}`}
          css={BettingHistoryShareBtnStyle}
          checked={checkedFold}
          onChange={onClickBetHistoryItemSelectHandler}
        >
          선택
        </Checkbox>
      )
    }
  } else {

    bettingHistoryFoldItem = (
      <Fragment>
        <Button TP className={ScoreBtnClass()}>
          {/* 이긴 팀의 스코어는 'win' class를 붙여주시면 됩니다. */}
          {makeDomScore()}
        </Button>
      </Fragment>
    )
  }
  const isLiveBetting = typeOn === BET_TYPE_ON.LIVE || typeOn === BET_TYPE_ON.UNIFIED_LIVE
    || producerId === ProducerType.LIVEODDS
  return (
    <ListItemFoldWrap>
      <div className="match-info">
        <span className="date">{dateOfMatchText}</span>
        <span>
          {bettingHistoryFoldItem}
          {requestButtonActive && KeepBtn()}
        </span>
      </div>
      <li className="list-item-fold-item select-rate">
        <span className="hit-state">{makeHitStateElement()}</span>
        <span className="select-match">
          {isLiveBetting && (<LiveTagIco/>)}
          {makeSelectMatchElement()}
          <span className="outcome-rate">{rateTemplate(outcomeRate)}</span>
        </span>
      </li>
      <li className="list-item-fold-item select-type">
        {marketName}
        {withBrace && '('}
        <span className="value">&nbsp;{specialBetValue}</span>
        {withBrace && ')'}
      </li>
      <li className="list-item-fold-item select-team">
        {isLsportsEnv() ? LS_SPORT_ID_ICON_MAP[sportId] : SPORT_ID_ICON_MAP[sportId]}
        <span className="team-name">
          (홈) {homeTeamName} vs {awayTeamName}
        </span>
      </li>
    </ListItemFoldWrap>
  )
})
